import { takeEvery, all, takeLatest } from "redux-saga/effects";

import * as actionTypes from "../actions/actionTypes";

import {
  getProfileDetailsSaga,
  updateCandidateStatusSaga,
  updateCandidateProfileImageSaga
} from './candidateProfile';

import {
  getTalentPoolsSaga,
  getTalentPoolsRecruiterSaga,
  viewCandidateRecruiterSaga
} from './talentPool';

import {
  getGroupTalentPoolsSaga,
  updateCandidatePrioritySaga
} from './candidateReview';

import {
  getClientDetailsSaga,
  getUserImageUrlSaga,
  getInterviewListSaga
} from './clientProfile'

export function* watchTalentPool() {    
  yield all([
    yield takeEvery(actionTypes.GET_TALENTPOOL, getTalentPoolsSaga),
    yield takeEvery(actionTypes.GET_TALENTPOOL_RECRUITER, getTalentPoolsRecruiterSaga),
    yield takeEvery(actionTypes.VIEW_CANDIDATE_RECRUITER, viewCandidateRecruiterSaga)
  ]);
}

export function* watchCandidateProfile() {
  yield all([
    takeEvery(actionTypes.UPDATE_CANDIDATE_STATUS, updateCandidateStatusSaga),
    takeEvery(actionTypes.GET_PROFILE_DETAILS, getProfileDetailsSaga),
    takeEvery(actionTypes.UPDATE_CANDIDATE_PROFILE_IMAGE, updateCandidateProfileImageSaga),
  ]);
}

export function* watchGroupTalentPool() {  
  yield all([  
    takeEvery(actionTypes.GET_GROUP_TALENTPOOL, getGroupTalentPoolsSaga),
    takeEvery(actionTypes.UPDATE_CANDIDATE_PRIORITY, updateCandidatePrioritySaga)
  ]);
}

export function* watchClientDetails() {  
  yield all([  
    takeEvery(actionTypes.GET_CLIENT_DETAILS, getClientDetailsSaga),
    takeEvery(actionTypes.GET_PROFILE_IMAGE, getUserImageUrlSaga),
    takeEvery(actionTypes.GET_INTERVIEWLIST_COUNT,getInterviewListSaga)
  ]);
}


// WEBPACK FOOTER //
// ./src/store/sagas/index.js